import { CSSProperties } from 'react';

const LogoIcon = ({
  fill = '#070E25',
  style,
}: {
  fill?: string;
  style?: CSSProperties;
}) => (
  <svg
    width="123"
    height="33"
    viewBox="0 0 123 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g clipPath="url(#clip0_3504_41119)">
      <path
        d="M21.3061 0H20.466C17.0118 0.119554 13.9228 1.68021 11.787 4.10359L4.11621 11.7744L9.13423 9.12161C10.0907 8.87927 11.0923 8.75002 12.1231 8.75002C18.8181 8.75002 24.2464 14.1784 24.2464 20.8734C24.2464 21.9041 24.1172 22.9058 23.8749 23.8622L21.2221 28.8802L28.8929 21.2094C31.3162 19.0736 32.8801 15.9879 32.9965 12.5305V0H21.3028H21.3061Z"
        fill={fill}
      />
      <path
        opacity="0.5"
        d="M21.3064 24.2268C21.1674 24.2301 21.0285 24.2365 20.8863 24.2365C20.7441 24.2365 20.6052 24.2301 20.4663 24.2268C14.1041 24.0104 8.98913 18.8954 8.77264 12.5332C8.76941 12.3943 8.76295 12.2553 8.76295 12.1132C8.76295 11.971 8.76941 11.832 8.77264 11.6931C8.80172 10.8078 8.92451 9.94827 9.13453 9.12109C9.01175 9.15341 8.89219 9.18572 8.77264 9.22126C3.70616 10.6785 0 15.3411 0 20.8729C0 27.5679 5.42837 32.9963 12.1234 32.9963C17.6551 32.9963 22.321 29.2901 23.775 24.2236C23.8105 24.1041 23.8461 23.9845 23.8752 23.8617C23.048 24.0717 22.1885 24.1945 21.3064 24.2236V24.2268Z"
        fill={fill}
      />
    </g>
    <path
      d="M105.774 4.69336H111.1L122.186 28.6081H116.894L114.449 23.4165H102.425L100.013 28.6081H94.6875L105.774 4.69336ZM104.2 19.5312H112.674L108.454 10.4208L104.2 19.5312Z"
      fill={fill}
    />
    <path
      d="M91.9925 24.3209V28.6081H71.8625V4.69336H77.0876V24.3209H91.9925Z"
      fill={fill}
    />
    <path
      d="M67.4273 14.1387V18.4259H52.6899V28.6081H47.4648V4.69336H68.1307V8.9806H52.6899V14.1387H67.4273Z"
      fill={fill}
    />
    <defs>
      <clipPath id="clip0_3504_41119">
        <rect width="33" height="33" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LogoIcon;
